/* eslint-disable prefer-const */
'use client'; // Error boundaries must be Client Components

import React from 'react';
import {ErrorPage} from '@udemy-v2/react-structure-components';
import {Header} from '@/components/header';
import {Footer} from '@/components/footer';
import {appConfig} from '@/app/lib/app-config';

// <<Stencil::Block(notFoundPageImports)>>
// <</Stencil::Block>>

export default function NotFound() {
    /**
     * Error content component for not-found page
     * Can be customized via Stencil block for project-specific 404 displays
     */
    const ErrorContent = () => {
        let errorContent = <ErrorPage />;
        // Override default error content below
        // <<Stencil::Block(notFoundPageContent)>>
        // <</Stencil::Block>>
        return errorContent;
    };

    return (
        <>
            {!appConfig.useDefaultLayout ? <Header /> : null}
            <ErrorContent />
            {!appConfig.useDefaultLayout ? <Footer /> : null}
        </>
    );
}
